import EmployeesListItem from "../employees-list-item/employees-list-item";

import './employees-list.css';

const EmployeesList = ({ data, onToggle, onDeleteItem, onChangeSalary }) => {
  const elementsRender = data.map(item => {
    const { id, ...itemProps } = item;

    return <EmployeesListItem
      key={id} {...itemProps}
      onToggle={(e) => onToggle(id, e.currentTarget.getAttribute('data-toggle'))}
      onDeleteItem={() => { onDeleteItem(id) }}
      onChangeSalary={(e) => { onChangeSalary(id, e.target.value) }}
    />
  })

  return (
    <ul className="app-list list-group">
      {elementsRender}
    </ul>
  )
}

export default EmployeesList;